
import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function loginReducer(state = initialState.session, action) {
	switch (action.type) {
		case types.LOGIN_MODEL_RECIEVED: {
			let stateToUpdate = mergeDeep({}, state);

			stateToUpdate.gebruikersnaam = action.body.voornaam + " " + action.body.naam;
			stateToUpdate.emailAdres = action.body.emailAdres;

			return stateToUpdate;
        }

		default:
			return state;
    }
}